import TableHeader from "@commons/Table/TableHeader";
import Table from "@commons/Table/TableContent";
import Heading from "@commons/Typography/Heading";
import ReleasesStatus from "./ReleasesStatus";
import { useReleasesData } from "@hooks/releases/useReleasesData";
import { prepareReleasesTable } from "@utils/translator/releases";
import { ReleasesColumns } from "@typings/entities/releases/table";
import { useNavigate } from "react-router-dom";
import type { Release } from "@typings/entities/releases";
import { useExportReleases } from "@hooks/exports/useExportReleases";

function AdminAnalysisTable() {
  const adminFilters = {
    status: "waiting_ok",
  };

  const {
    releases,
    isLoading,
    totalItems,
    rowsPerPage,
    page,
    handlePageChange,
    handleRowsPerPageChange,
  } = useReleasesData("table", adminFilters);

  const navigate = useNavigate();

  const { handleExport, isLoading: isExporting } = useExportReleases();

  const processedAdminReleases = prepareReleasesTable(releases);

  const handleView = (release: Release) => {
    navigate(`/managing-releases/${release.id}`);
  };

  const heads = ReleasesColumns;

  return (
    <div className="w-full">
      <div className="w-full mt-6 flex flex-col justify-center items-center text-center bg-white rounded-lg shadow-md p-4">
        <TableHeader.Root>
          <Heading>Aguardando Análise do Admin</Heading>
          <TableHeader.Button
            customVariant="dark"
            onClick={() => handleExport({ status: "waiting_ok" })}
            disabled={isExporting}
          >
            {isExporting ? "Exportando..." : "Exportar .csv"}
          </TableHeader.Button>
        </TableHeader.Root>

        <Table.Root isLoading={isLoading}>
          <Table.Head heads={heads} actions={true} />
          <Table.Body
            rows={processedAdminReleases}
            columns={heads.map((head) => head.id)}
            columnFormatters={{ status: ReleasesStatus }}
            actions={["view"]}
            onView={handleView}
          />
          <Table.Footer
            colSpan={heads.length}
            count={totalItems}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        </Table.Root>
      </div>
    </div>
  );
}

export default AdminAnalysisTable;
